<div [formGroup]="form" class="mb-3 general-select">
    <label [for]="controlName" class="tipoLetra" [ngClass]="isReFill ? 'label-refill' : ''">
        *{{label}}
    </label>
    
    <select [formControlName]="controlName" 
            required 
            [id]="controlName" 
            class="form-select" 
            [disabled]="isDisabled"
            [ngClass]="isReFill ? 'select-refill' : ''"> 
        
        <!-- Opción placeholder opcional -->
        <option *ngIf="showPlaceholder" value="" disabled>{{placeholder}}</option>
        
        <!-- Opciones dinámicas -->
        <option *ngFor="let option of options" 
                [value]="option.value" 
                [disabled]="isOptionDisabled(option)">
            {{option.label}}
        </option>
    </select>
    
    <!-- Mostrar errores del formulario -->
    <div *ngIf="form.get(controlName)?.invalid && form.get(controlName)?.touched" 
         class="text-danger small mt-1">
        <div *ngIf="form.get(controlName)?.errors?.['required']">
            {{label}} es requerido
        </div>
    </div>
</div>